import React, { useState, useEffect, useRef } from 'react';
import SettingIcon from "assets/fix_assets/setting_icon.svg";
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { getMatchingCategory, getMatchingSubCategory, getMatchingSubDetailCategory } from 'firebase_/firebase_function/matching';
import FixRequestList from 'components/fix_request/fix_category_list';
import StepIndicator from 'components/fix_request/mobile/step_indicator_m';
import { useFixRequest } from 'util/context/fix_request_context';
import FixRequestWriteMobile from './fix_request_write_mobile';
import BackArrow from "assets/community_assets/write/header/back_arrow_icon.svg"
import FixRequestEditMobile from './fix_request_edit_mobile';

export default function FixRequestMobile() {
    /// ✅ 요청 수정시 docId
    const { docId } = useParams();

    const navigate = useNavigate();
    const { _categoryList, _setCategoryList, _selectCategory, _setSelectCategory } = useFixRequest();

    const [categoryList, setCategoryList] = useState({/// ✅ 카테고리 리스트
        mainCategory: [], // 대분류 
        subCategory: [], // 중분류
        detailSubCategory: [], // 소분류
    });

    const [selectCategory, setSelectCategory] = useState({ /// ✅ 선택한 카테고리
        mainCategory: {
            index: -1,
            name: "",
        }, // 대분류 
        subCategory: {
            index: -1,
            name: "",
        }, // 중분류
        detailSubCategory: {
            index: -1,
            name: "",
        }, // 소분류
    })

    const [categoryStep, setCategoryStep] = useState(1); /// ✅ 분류 단계
    const [pageStep, setPageStep] = useState(1); /// ✅ 페이지 단계

    useEffect(() => {
        fetchCategory(1); /// 대분류 불러오기
        // context값 초기화
        _setCategoryList({});
        _setSelectCategory({});
    }, [])

    /// ✅ 카테고리 리스트
    const fetchCategory = async (_step, _tag) => {
        let responseData = [];

        switch (_step) {
            case 1: // 대분류
                responseData = await getMatchingCategory();
                setCategoryList((prev) => ({
                    ...prev,
                    mainCategory: responseData,
                }));
                break;
            case 2: // 중분류
                responseData = await getMatchingSubCategory(_tag);

                setCategoryList((prev) => ({
                    ...prev,
                    subCategory: responseData,
                }));
                break;
            case 3: // 소분류
                responseData = await getMatchingSubDetailCategory(_tag);

                setCategoryList((prev) => ({
                    ...prev,
                    detailSubCategory: responseData,
                }));
                break;
            default:
                break;
        }

        // 리스트가 비어있는지 체크
        return responseData;
    }

    /// ✅ 카테고리 선택
    const handleCategoryClick = async (_index, _name, _tag) => {
        switch (categoryStep) {
            case 1: // 대분류 선택
                setSelectCategory((prev) => ({ ...prev, mainCategory: { index: _index, name: _name, tag: _tag } }));
                break;
            case 2: // 중분류 선택
                setSelectCategory((prev) => ({ ...prev, subCategory: { index: _index, name: _name, tag: _tag } }));
                break;
            case 3: // 소분류 선택
                setSelectCategory((prev) => ({ ...prev, detailSubCategory: { index: _index, name: _name, tag: _tag } }));
                break;
            default:
                break;
        }
    }

    /// ✅ 다음단계
    const handleNextStep = async () => {
        let response;

        switch (categoryStep) {
            case 1: // 대분류 선택
                if (selectCategory.mainCategory.name) {
                    response = await fetchCategory(categoryStep + 1, selectCategory.mainCategory.tag ?? "기타");
                }
                break;
            case 2: // 중분류 선택
                if (selectCategory.subCategory.name) {
                    response = await fetchCategory(categoryStep + 1, selectCategory.subCategory.tag ?? "기타");
                }
                break;
            case 3: // 소분류 선택
                response = [];
                break;
            default:
                break;
        }

        // 다음분류 데이터있으면 categoryStep 진행
        if (response.length > 0) {
            setCategoryStep((prev) => prev + 1);
        } else {
            setCategoryStep(4);
            await new Promise((resolve) => setTimeout(resolve, 300)); // 애니메이션 0.3초 기다림
            setPageStep(2);

            // context값 업데이트
            _setSelectCategory(selectCategory);
        }
    }

    /// ✅ 뒤로가기
    const pressedBack = () => {
        switch (pageStep) {
            case 1:
                switch (categoryStep) {
                    case 1:
                        docId ? navigate(`/matching/${docId}`) : navigate("/main")
                        break;
                    case 2:
                        setCategoryStep((prev) => prev - 1);
                        resetSelectCategory(2);
                        break;
                    case 3:
                        setCategoryStep((prev) => prev - 1);
                        resetSelectCategory(1);
                        break;
                    case 4:
                        setCategoryStep((prev) => prev - 1);
                        setPageStep(1);
                        resetSelectCategory(1);
                        break;
                    default:
                        break;
                }
                break;
            case 2:
                if (categoryList.subCategory.filter((list) => list.name !== "기타").length === 0 &&
                    categoryList.detailSubCategory.filter((list) => list.name !== "기타").length === 0) { /// ✅ 중분류 소분류 다 비어있을때
                    setCategoryStep(1);
                    resetSelectCategory(2);
                } else if (categoryList.detailSubCategory.filter((list) => list.name !== "기타").length === 0) { /// ✅ 소분류 비어있을때
                    setCategoryStep(2);
                    resetSelectCategory(1);
                } else { /// ✅ 다 길이가 있을때
                    setCategoryStep(3);
                }
                setPageStep(1);
                break;
            case 3:
                setPageStep(2);
                break;
            default:
                setPageStep(2);
                break;
        }
    }

    /// ✅ 선택한 카테고리 리셋
    const resetSelectCategory = (amount) => {
        /// ✅ 2개면 sub,detailSub 나머진 detailSub만
        if (amount == 2) {
            setSelectCategory((prev) => ({
                ...prev,
                subCategory: {
                    index: -1,
                    name: "",
                },
                detailSubCategory: {
                    index: -1,
                    name: "",
                },
            }))
        } else {
            setSelectCategory((prev) => ({
                ...prev,
                detailSubCategory: {
                    index: -1,
                    name: "",
                },
            }))
        }
    }

    return (
        <div style={{ backgroundColor: "#00000000", display: "flex", flexDirection: "column", height: "100vh" }}>
            <div style={{ width: "100%", padding: "16px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                <img src={BackArrow} style={{ cursor: "pointer" }} onClick={() => pressedBack()} />
                <div className="f18_1F2937_W600">
                    {docId ? "수리요청 수정" : "수리요청"}
                </div>
                <div style={{ width: "18px" }}>
                </div>
            </div>

            {/* 분류 진행도 */}
            <StepIndicator
                categoryStep={categoryStep}
                pageStep={pageStep}
            />

            {
                categoryStep === 1 && (
                    <FixRequestList
                        title={"요청 상세 (대분류)"}
                        categoryList={categoryList.mainCategory}
                        handleCategoryClick={handleCategoryClick}
                        selectCategory={selectCategory.mainCategory}
                    />
                )
            }

            {
                categoryStep === 2 && (
                    <FixRequestList
                        title={"요청 상세 (중분류)"}
                        categoryList={categoryList.subCategory}
                        handleCategoryClick={handleCategoryClick}
                        selectCategory={selectCategory.subCategory}
                    />
                )
            }

            {
                categoryStep === 3 && (
                    <FixRequestList
                        title={"요청 상세 (소분류)"}
                        categoryList={categoryList.detailSubCategory}
                        handleCategoryClick={handleCategoryClick}
                        selectCategory={selectCategory.detailSubCategory}
                    />
                )
            }

            {/* 수정 / 글쓰기 */}
            {
                docId ? (
                    pageStep !== 1 && (
                        <FixRequestEditMobile pressedUpdate={async () => {
                            setPageStep(3);
                            await new Promise((resolve) => setTimeout(resolve, 300)); // 애니메이션 0.4초 기다림
                            setPageStep(4);
                            await new Promise((resolve) => setTimeout(resolve, 100));
                            return;
                        }} />
                    )
                ) : (
                    pageStep !== 1 && (
                        <FixRequestWriteMobile pressedUpdate={async () => {
                            setPageStep(3);
                            await new Promise((resolve) => setTimeout(resolve, 300)); // 애니메이션 0.4초 기다림
                            setPageStep(4);
                            await new Promise((resolve) => setTimeout(resolve, 100));
                            return;
                        }} />
                    )
                )
            }


            {/* BottomNavigator */}
            {categoryStep !== 4 && (
                <div style={{
                    display: 'flex',
                    flexDirection: "column",
                    padding: "16px",
                    borderTop: "1px solid #E5E7EB",
                    backgroundColor: "#ffffff",
                    bottom: "0",
                    width: "100%",
                    boxSizing: "border-box",
                }}>
                    <div
                        // onClick={() => navigate("/fix_request/write")}
                        onClick={() => handleNextStep()}
                        className='f16_FFFFFF_W500'
                        style={{
                            display: 'flex',
                            justifyContent: "center",
                            alignItems: "center",
                            padding: '18px',
                            backgroundColor: "#2E4A24",
                            borderRadius: "8px",
                            cursor: 'pointer'
                        }}
                    >
                        다음 단계로
                    </div>
                </div>
            )}
        </div >
    );
}